/* 
 * Export component file to be used on project
*/

import Row from './Row.js';
export default Row;
